import { Expose, Type } from 'class-transformer';
import { SurveyElement } from '@/models/survey-elements/element';
import { SurveyElementsUnion } from '@/models//survey-elements-union';
import { BaseDiscriminatorConfig } from '@/models/survey-elements/survey-element-discriminator';
import { COMPONENT_TYPES } from '@/models/enums/component-types.enum';

export class SurveyGroupingElement extends SurveyElement {
  @Type(() => SurveyElement, {
    discriminator: {
      property: 'element_type',
      subTypes: [
        ...BaseDiscriminatorConfig(),
        { value: SurveyGroupingElement, name: COMPONENT_TYPES.GROUPING_ELEMENT },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  elements!: SurveyElementsUnion[];

  outlined?: boolean;
}
